<!-- No workspaces message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noWorkspaces && !loading"
>
  {{ 'info.no_workspaces' | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div class="table-wrapper" [class.loading]="loading" [style.min-height.px]="containerHeight" *ngIf="!noWorkspaces">
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table
    mat-table
    [dataSource]="items"
    [trackBy]="trackByWorkspaceId"
    class="spotlab-table"
    matSort
    [class.dimmed]="loading"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.name' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let workspace">
        {{ workspace.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="caseType">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.case_type' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let workspace">
        <ts-loading-attribute
          [value]="workspace.caseType?.name || undefined"
          class="flex-row align-items-center justify-left"
          style="flex: 0 0 80px"
        ></ts-loading-attribute>
      </td>
    </ng-container>
    <ng-container matColumnDef="storage">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.storage' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let workspace">
        {{ workspace.usedStorage | storage }}
      </td>
    </ng-container>
    <ng-container matColumnDef="stats">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.stats' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let workspace">
        <div class="flex-row align-items-center">
          <ts-loading-attribute
            icon="ri-group-line"
            [value]="workspace.numMembers"
            class="flex-row align-items-center justify-left text-gray"
            style="flex: 0 0 80px"
            [tooltip]="'tooltip.workspaces.numMembers' | translate"
          ></ts-loading-attribute>
          <ts-loading-attribute
            icon="ri-briefcase-4-line"
            [value]="workspace.numCases"
            class="flex-row align-items-center justify-left text-gray"
            style="flex: 0 0 80px"
            [tooltip]="'tooltip.workspaces.numCases' | translate"
          ></ts-loading-attribute>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let workspace; columns: columns" (click)="workspaceClicked.emit(workspace)"></tr>
  </table>
</div>
